import React from 'react';
import classNames from 'classnames';
import { StepperProgressCircle } from './StepperProgressCircle';
import styles from './Stepper.module.scss';

export type StepperMobileProps = {
  activeStep: number;
  steps: number;
  label: string;
  description: string;
  className?: string;
};

export function StepperMobile({
  className,
  activeStep,
  steps,
  label,
  description,
}: StepperMobileProps) {
  const validStep = (): number => {
    if (activeStep < 1) return 1;
    if (activeStep > steps) return steps;

    return activeStep;
  };

  return (
    <div className={classNames(styles.stepperMobile, className)} role="group">
      <div className={styles.stepperMobileContainer}>
        <StepperProgressCircle
          activeStep={validStep()}
          isDone={validStep() === steps}
          steps={steps}
        />
        <div className={styles.stepperContainerTitle}>
          <p className={styles.stepperParagraph}>{label}</p>
          <p className={styles.stepperSubParagraph}>{description}</p>
        </div>
      </div>
      <hr className={styles.stepperDivider} />
    </div>
  );
}
